//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import { IssueIssueFilter, IssueParentIssueFilter } from "shared/search/containers/Filter/IssueFilters"

const defaultPropTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const IssueIssuesFilterGroup = (props) => genericFilterGroup(props)
IssueIssuesFilterGroup.propTypes = defaultPropTypes
IssueIssuesFilterGroup.defaultProps = {
    filters: [IssueIssueFilter, IssueParentIssueFilter],
    uniqueFilterGroupId: "issueIssuesFilterGroup",
    displayLabel: "Issues",
    helpText: "Filter issues by their parent",
}
